export default "__VITE_ASSET__BgMQgb6K__"